import associatesIcon from '../assets/associatesIcon.svg'
import dashboardIcon from '../assets/dashboardIcon.svg'
import designationIcon from '../assets/designationIcon.svg'
import directoryIcon from '../assets/directoryIcon.svg'
import orgTreeIcon from '../assets/orgTreeIcon.svg'

const logos = [
  dashboardIcon,
  designationIcon,
  associatesIcon,
  directoryIcon,
  orgTreeIcon,
]

export default logos